module.exports = __webpack_public_path__ + "static/img/アセット 84@3x.d856b94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 84@3x.png
// module id = b7d9
// module chunks = 1